import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import config from '../functions/config';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faRightFromBracket,
  faBook,
  faListCheck,
  faCartShopping,
  faBagShopping,
} from "@fortawesome/free-solid-svg-icons";

const PurchaseHistory = () => {
  const [purchases, setPurchases] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [message, setMessage] = useState("");

  // Fetch purchase history from the API
  useEffect(() => {
    fetchPurchaseHistory();
  }, []);

  const fetchPurchaseHistory = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/purchase-history/`);
      const data = await response.json();
      const sortedPurchases = data.sort((a, b) => new Date(b.purchase_date) - new Date(a.purchase_date)); // Sort by latest purchase
      setPurchases(sortedPurchases);
    } catch (error) {
      console.error("Error fetching purchase history:", error);
      setMessage("Failed to load purchase history.");
    }
  };

  // Filter purchases based on search term
  const filteredPurchases = purchases.filter(
    (purchase) =>
      purchase.item_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      purchase.user_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light fixed-top">
        <a className="navbar-brand text-light" href="#">Admin</a>
        <button className="navbar-toggler bg-light" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto flex-column vertical-nav px-3">
            <li className="nav-item">
              <a className="nav-link text-light" href="/admin">
                <span className="nav-icon"><FontAwesomeIcon icon={faTachometerAlt} /></span>
                <span className="nav-text">Dashboard</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/register-book">
                <span className="nav-icon"><FontAwesomeIcon icon={faBook} /></span>
                <span className="nav-text">Register Book</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/list-users">
                <span className="nav-icon"><FontAwesomeIcon icon={faUsers} /></span>
                <span className="nav-text">Manage User</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/view-books">
                <span className="nav-icon"><FontAwesomeIcon icon={faListCheck} /></span>
                <span className="nav-text">Manage Book</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/adminpurchase">
                <span className="nav-icon"><FontAwesomeIcon icon={faCartShopping} /></span>
                <span className="nav-text text-warning">Purchase History</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/adminrent">
                <span className="nav-icon"><FontAwesomeIcon icon={faBagShopping} /></span>
                <span className="nav-text">Rental History</span>
              </a>
            </li>
          </ul>
          <ul className="navbar-nav ml-auto pr-5">
            <li className="nav-item mr-5">
              <a className="nav-link text-light fixed-right" href="/login">
                <FontAwesomeIcon icon={faRightFromBracket} /> Logout
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="container content px-5 mt-5 pt-4">
        <h2>Purchase History</h2>
        {message && <div className="alert alert-danger">{message}</div>}

        {/* Search Bar */}
        <div className="mb-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search by item or user..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Purchase History Table */}
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Item Name</th>
                <th>User</th>
                <th>Quantity</th>
                <th>Total Price</th>
                <th>Purchase Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredPurchases.length > 0 ? (
                filteredPurchases.map((purchase, index) => (
                  <tr key={purchase.id}>
                    <td>{index + 1}</td>
                    <td>{purchase.item_name}</td>
                    <td>{purchase.user_name}</td>
                    <td>{purchase.quantity}</td>
                    <td>${purchase.total_price.toFixed(2)}</td>
                    <td>{new Date(purchase.purchase_date).toLocaleDateString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No purchase history found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <style jsx>{`
        .content {
          margin-left: 200px;
        }
        @media (max-width: 768px) {
          .vertical-nav {
            width: 100%;
          }
          .content {
            margin-left: 0;
          }
          .navbar {
            padding: 10px;
          }
        }

        .navbar {
          background: #1a1a1a; /* Dark background color */
        }

        .vertical-nav {
          background: #1a1a1a; /* Dark background color */
          position: fixed;
          top: 56px;
          left: 0;
          height: calc(100% - 56px);
          overflow-y: auto;
          padding-top: 30px;
          z-index: 999;
        }

        .vertical-nav .nav-link {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding: 10px 15px;
          color: #ff6700; /* Dark orange font color */
          transition: background-color 0.3s; /* Smooth hover effect */
        }

        .vertical-nav .nav-link:hover {
          background-color: #2a2a2a; /* Slightly lighter background for hover effect */
        }

        .nav-icon {
          font-size: 20px;
          margin-right: 10px;
          color: #ff6700; /* Dark orange for icons */
        }

        li {
          border-bottom: 2px solid black;
        }

        li:hover {
          background-color: #2a2a2a; /* Slightly lighter background for hover effect */
        }

        body {
          position: relative;
          margin: 0;
          padding: 0;
        }

        body::before {
          content: '';
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('https://wallpaperaccess.com/full/934072.jpg') no-repeat center center fixed;
          background-size: cover;
          opacity: 0.4;
          z-index: -1;
        }

        a {
          text-decoration: none;
        }

        h1, h2, h3, h4, h5, h6 {
          font-family: "Times New Roman", Times, serif;
          color: #1a1a1a;
        }
      `}</style>
    </div>
  );
};

export default PurchaseHistory;
